import React, { Fragment, useEffect, useState } from 'react';

import CPMDetailsComponent from './CPMDetailsComponent';
import SiteReadinessAccordion from './SiteReadinessAccordion';
import FooterComponent from './FooterComponent';
import FooterMultisiteComponent from './FooterMultisiteComponent';
import { Notification } from 'featureLib/NotificationComponent';

import StepsHeader from 'home/components/functional/steps-header/steps.component';

import { CPM_DETAILS_FORM_CONFIG } from 'featureLib/ConfirmInstallationComponent/constant';
import { getCurrentLead, getCurrentOrder } from 'tokenGeneration/lead.util';
import { isOrderConfirmationUrl } from 'dedicated/services/summary.service';
import { NOTIFICATION_TYPE } from 'featureLib/NotificationComponent';

import './index.scss';
import { CIRCLE_WISE, ORDER_TYPE } from 'common/constants/app.constants';
import { fetchKycConfig } from 'home/view/manage-feasibility/services';
import { DEFAULT_TOAST_MSG } from 'home/view/manage-feasibility/constants';
import { trackAnalytics } from 'common/utils/app.utils';
import { fetchOrder as fetchOrderAsync } from 'common/services/http.service';

const ConfirmInstallationComponent = (props) => {
  const isMultiSite = (props && props.location && props.location.state && props.location.state.isMultiSite) || false;

  // cpm states
  const [cpmAccordionMeta, setCpmAccordionMeta] = useState({
    isExpanded: true,
    isValidated: false
  });
  const [cpmFormSchema, setCpmFormSchema] = useState(CPM_DETAILS_FORM_CONFIG);
  const [error, setError] = useState('');

  // site readiness states
  const [siteReadinessAccordionMeta, setSiteReadinessAccordionMeta] = useState({
    isExpanded: true,
    isValidated: false
  });
  const [selectedOption, setSelectedOption] = useState({});
  const [appointmentData, setAppointmentData] = useState({});
  const [customerNeedByDate, setCustomerNeedByDate] = useState('');
  const [siteReadyByDate, setSiteReadyByDate] = useState('');
  const [appointmentId, setSelectedAppointmentId] = useState('');
  const [tableData, setTableData] = useState([]);
  const [selectedLineItem, setSelectedLineItem] = useState({});
  const [slotBooked, setSlotBooked] = useState(false);
  const [isOrderConfirmation, setIsOrderConfirmation] = useState(isOrderConfirmationUrl());
  const [notification, setNotification] = useState({ show: false, email: '', message: '' });
  const [circleData, setCircleData] = useState(null);

  // footer states
  const [showWidget, setShowWidget] = useState(false);

  const handleCircleWise = async () => {
    try {
      const { res, err } = await fetchKycConfig();
      if (res) {
        const {
          data: {
            success = false,
            result: {
              featureConfig: { slotReserve }
            }
          } = {}
        } = res;

        /** negative mock */
        // const mockSlotReserve = {
        //   allCircles: false,
        //   eligibleCircles: ["GUJ", "EEE"]
        // };

        if (success) {
          setCircleData(slotReserve);
          // setCircleData(mockSlotReserve);
        }
      } else if (err) {
        const errorMsg = (err && err.response && err.response.data && err.response.data.errorMsg) || DEFAULT_TOAST_MSG;
        throw new Error(errorMsg);
      }
    } catch (err) {
      const errorMsg = (err && err.response && err.response.data && err.response.data.errorMsg) || DEFAULT_TOAST_MSG;
      throw new Error(errorMsg);
    }
  };

  const fetchOrder = async () => {
    const res = await fetchOrderAsync();
    console.log(res);
  };
  useEffect(() => {
    // showSteps(true);
    const orderStatus = getCurrentOrder()?.orderStatus;
    const data = getCurrentOrder();
    trackAnalytics({
      eVar0: `b2b|${data?.serviceType}|buy|confirm installations|site readiness widget`,
      prop0: `b2b|${data?.lead?.customer?.segment}|${data?.serviceType}`,
      prop15: data?.customerEmail || '',
      prop17: `${data?.lead?.customer?.authorizedSignatory?.firstName || ''} ${data?.lead?.customer?.authorizedSignatory?.lastName || ''}`,
      prop14: data?.lead?.customer?.authorizedSignatory?.phoneNumber || '',
      prop35: data?.companyAddress?.officeName || '',
      prop39: data?.lead?.customer?.segment || '',
      prop40: data?.serviceType || '',
      prop37: data?.orderType || '',
      // prop41=<type of site>
      // Prop43=<no. of sites>
      prop21: data?.lead?.connectivityLineItems?.[0]?.feasibilityId || '', //feasibility request id
      // Prop23=<link id>
      prop9: data?.companyAddress?.pincode || '',
      prop36: data?.companyAddress?.officeName || '',
      prop20: data?.companyAddress?.addressLine1 || '',
      prop26: data?.lead?.connectivityLineItems?.[0]?.planDetail?.speed || '',
      // Prop28=<site type>
      prop10: data?.orderId || '',
      prop29: data?.lead?.connectivityLineItems?.[0]?.selectedMedia?.[0]?.media || '',
      prop22: data?.lead?.connectivityLineItems?.[0]?.planDetail?.planPeriod || '',
      prop18: data?.lead?.planDetail?.totalPrice || '',
      prop1: data?.purchaseOrder?.poNumber || '',
      prop24: data?.documents?.PURCHASE_ORDER?.PO_DOCUMENT || '',
      prop25: data?.purchaseOrder?.purchaseOrderDate || '',
      prop2: data?.purchaseOrder?.poAmount || '',
      prop3: data?.billingType || '',
      prop4: data?.billingCycle || '',
      prop5: data?.lead?.customer?.panNumber || '',
      prop16: data?.companyAddress?.city || '',
      prop7: data?.siteIncharge?.firstName || '',
      prop8: data?.siteIncharge?.phoneNumber || '',
      prop9: data?.siteIncharge?.email || '',
      prop37: data?.lead?.connectivityLineItems?.[0]?.customerNeedDate || '',
      prop38: data?.fiscalCode?.id || ''
      // Prop11=<full name of CPM>
      // Prop12=<mobile number of CPM>
      // Prop13=<email address of CPM>
    });
    const defaultSiteReadyByDate = getCurrentOrder()?.lead?.connectivityLineItems?.[0]?.siteReadinessDate;
    const defaultCustomerNeedByDate = getCurrentOrder()?.lead?.connectivityLineItems?.[0]?.customerNeedDate || getCurrentOrder()?.lead?.connectivityLineItems?.[0]?.estimatedDate;
    if (orderStatus !== ORDER_TYPE.ORDER_IN_PROGRESS) {
      setCustomerNeedByDate(defaultCustomerNeedByDate ? new Date(defaultCustomerNeedByDate) : '');
      setSiteReadyByDate(defaultSiteReadyByDate ? new Date(defaultSiteReadyByDate) : '');
    }

    if (CIRCLE_WISE) {
      handleCircleWise();
    }
  }, [isOrderConfirmation]);

  return (
    <Fragment>
      <Notification
        onCancel={() => setNotification({ show: false, hideNotificaton: true })}
        show={notification.show && !notification.hideNotificaton}
        type={NOTIFICATION_TYPE.ORDER_CONFIRMATION}
        message={notification.message}
        eventHandler={() => {}}
      />
      <StepsHeader
        disabledChoosePlan={true}
        skipNetworkstatus={true}
        disabled={true}
        activeStepIndex={5}
        isdedicatedJourney={true}
        isUnAuthJourney={false}
        showFeasibilityStatus={''}
        orderDetail={getCurrentOrder?.()}
      />
      <div className="order_form installation_details_page">
        <CPMDetailsComponent
          accordionMeta={cpmAccordionMeta}
          setAccordionMeta={setCpmAccordionMeta}
          cpmFormSchema={cpmFormSchema}
          setCpmFormSchema={setCpmFormSchema}
          tableData={tableData}
          isOrderConfirmation={isOrderConfirmation}
        />
        <SiteReadinessAccordion
          accordionMeta={siteReadinessAccordionMeta}
          setAccordionMeta={setSiteReadinessAccordionMeta}
          cpmAccordionMeta={cpmAccordionMeta}
          setCpmAccordionMeta={setCpmAccordionMeta}
          selectedOption={selectedOption}
          setSelectedOption={setSelectedOption}
          appointmentData={appointmentData}
          setAppointmentData={setAppointmentData}
          siteReadyByDate={siteReadyByDate}
          setSiteReadyByDate={setSiteReadyByDate}
          showWidget={showWidget}
          setShowWidget={setShowWidget}
          isMultiSite={isMultiSite}
          tableData={tableData}
          setTableData={setTableData}
          setSelectedLineItem={setSelectedLineItem}
          slotBooked={slotBooked}
          setSlotBooked={setSlotBooked}
          customerNeedByDate={customerNeedByDate}
          setCustomerNeedByDate={setCustomerNeedByDate}
          error={error}
          setError={setError}
          isOrderConfirmation={isOrderConfirmation}
          circleData={circleData}
          cpmFormSchema={cpmFormSchema}
        />
        {isMultiSite ? (
          <FooterMultisiteComponent
            setNotification={setNotification}
            cpmAccordionMeta={cpmAccordionMeta}
            cpmFormSchema={cpmFormSchema}
            siteReadinessAccordionMeta={siteReadinessAccordionMeta}
            selectedOption={selectedOption}
            appointmentData={appointmentData}
            setAppointmentData={setAppointmentData}
            siteReadyByDate={siteReadyByDate}
            setSiteReadyByDate={setSiteReadyByDate}
            showWidget={showWidget}
            setShowWidget={setShowWidget}
            appointmentId={appointmentId}
            setSelectedAppointmentId={setSelectedAppointmentId}
            tableData={tableData}
            selectedLineItem={selectedLineItem}
            setSlotBooked={setSlotBooked}
            isOrderConfirmation={isOrderConfirmation}
            setIsOrderConfirmation={setIsOrderConfirmation}
            circleData={circleData}
            {...props}
          />
        ) : (
          <FooterComponent
            setNotification={setNotification}
            cpmAccordionMeta={cpmAccordionMeta}
            cpmFormSchema={cpmFormSchema}
            siteReadinessAccordionMeta={siteReadinessAccordionMeta}
            selectedOption={selectedOption}
            appointmentData={appointmentData}
            setAppointmentData={setAppointmentData}
            siteReadyByDate={siteReadyByDate}
            setSiteReadyByDate={setSiteReadyByDate}
            showWidget={showWidget}
            setShowWidget={setShowWidget}
            appointmentId={appointmentId}
            setSelectedAppointmentId={setSelectedAppointmentId}
            customerNeedByDate={customerNeedByDate}
            setCustomerNeedByDate={setCustomerNeedByDate}
            error={error}
            setError={setError}
            isOrderConfirmation={isOrderConfirmation}
            setIsOrderConfirmation={setIsOrderConfirmation}
            circleData={circleData}
            {...props}
          />
        )}
      </div>
    </Fragment>
  );
};

export default ConfirmInstallationComponent;
